function GridCards({ children, colunas = 4 }) {
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: `repeat(${colunas}, 1fr)`,
        gap: "16px",
      }}
    >
      {children}
    </div>
  );
}

export default GridCards;
